// gatsby-browser.js
import React from "react";
import { LanguageProvider } from "./src/contexts/LanguageContext";

// Import Prism.js CSS for syntax highlighting
import "prismjs/themes/prism-tomorrow.css";

// Import custom CSS overrides for better integration
import "./src/styles/prism-overrides.css";

// Envolver toda la aplicación con LanguageProvider
export const wrapRootElement = ({ element }) => {
  return (
    <LanguageProvider defaultLanguage="es">
      {element}
    </LanguageProvider>
  );
};
